import { _, ts } from '_core';

import { DraftParams } from './types';

export const validate = (params: DraftParams) => {
  const errors = [];
  if (_.isNil(params.window)) errors.push('Window is required field.');
  if (!params.weights) errors.push('Weights is a required field.');
  return errors;
};

export const getName = (params: DraftParams) => {
  const weightsTitle = {
    [ts.enums.REPORT_ENUMS.WEIGHTS_ENUM.MINIMUM_VOLATILITY]: 'Minimum Volatility',
    [ts.enums.REPORT_ENUMS.WEIGHTS_ENUM.MARKET_CAP]: 'Market Capitalization',
    [ts.enums.REPORT_ENUMS.WEIGHTS_ENUM.EQUAL]: 'Equal',
    [ts.enums.REPORT_ENUMS.WEIGHTS_ENUM.MARKET_NEUTRAL]: 'Market Neutral',
  };

  const label = `Predicted vs. Realized Risk over Time - ${params.window} Day${params.window == 1 ? '' : 's'} Return`;
  const weightsLabel = weightsTitle[params.weights];
  if (weightsLabel) {
    return `${label} (${weightsLabel})`;
  }

  return label;
};

export type Tab = 'total' | 'style' | 'industries' | 'specific' | 'specific_by_quantile';

export const transform = (data: ts.types.widgets.TableData, tab: Tab, riskModel?: ts.types.riskModel.RiskModel) => {
  const specificCols = ['Forecast Specific Risk', 'Realized Specific Risk', 'Realized - Forecast Specific Risk'];
  const totalCols = ['Forecast Risk', 'Realized Risk', 'Realized - Forecast Risk'];
  const riskStyleFactors = riskModel?.definition.style || [];

  return data?.map((item) => {
    const newItem = { date: item.date } as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key !== 'date') {
        if ((tab == 'specific' && specificCols.includes(key)) || (tab == 'total' && totalCols.includes(key)))
          newItem[key] = item[key];
        else if (tab == 'specific_by_quantile' && key.startsWith('realized_minus_forecast_specific_risk_Q')) {
          const quantile = key.replace('realized_minus_forecast_specific_risk_', '');
          newItem['Forecast Risk ' + quantile] = item[key];
        } else if (tab == 'style' && key.startsWith('_handle_')) {
          const newHandle = key.replace('_handle_', '');
          const styleFactorName = riskStyleFactors.find((rf) => rf.handle == newHandle)?.name || _.startCase(newHandle);
          newItem[styleFactorName] = item[key];
        } else if (tab == 'industries' && key.startsWith('_industry_'))
          newItem[key.replace('_industry_', '')] = item[key];
      }
    });
    return newItem;
  });
};
